import {component_tool} from "@/tool";
import React from "react";
import GroupUserSelect from "./personSelect/groupUserSelect";

let {WizModal} = component_tool;
//配置项
let componentName = 'groupUserManagement';
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "createBy",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "groupId",
    name: "groupId",
    searchItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  // {
  //   title: "用户组名称",
  //   name: "searchGroupName",
  //   searchItem: {}
  // },
  {
    title: "用户组名称",
    name: "groupName",
    tableItem: {}
  },
  // {
  //   title: "用户组编号",
  //   name: "searchGroupCode",
  //   searchItem: {}
  // },
  {
    title: "用户组编号",
    name: "groupCode",
    tableItem: {}
  },
  {
    title: "用户姓名",
    name: "searchFullName",
    searchItem: {}
  },
  {
    title: "用户姓名",
    name: "fullName",
    tableItem: {}
  },
  {
    title: "用户账号",
    name: "searchUserName",
    searchItem: {}
  },
  {
    title: "用户账号",
    name: "userName",
    tableItem: {}
  },
  {
    title: "创建日期",
    name: "createTime",
    tableItem: {},
    formItem: {
      type: "hidden"
    }
  }
];

const templateConfig = (data) => {
  const {groupId, state} = data;
  let buttonSort = [];
  if (state && state === 'ENABLE') {
    buttonSort = ['batchAddUser', 'delete'];
  } else {
    buttonSort = ['delete'];
  }
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: buttonSort,
          buttons: [
            {
              key: "batchAddUser",
              custom: true,
              params: {children: "批量添加用户", type: "primary"},
              customOnClick: {
                key: "modal",
                style: {minWidth: 500},
                params: {
                  modalParams: {
                    title: "用户选择",
                    diy: (e) => (
                      <GroupUserSelect
                        {...e}
                        groupId={groupId} key={new Date()}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    ),
                    onOk: () => {
                      ref._ok(data);
                    },
                    width: 1200
                  }
                }
              }
            }
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateView: [
          // {
          //   key: "modal2",
          //   custom: true,
          //   params: {children: "用户组人员管理"},
          //   customOnClick: {
          //     key: "modal",
          //     params: {
          //       modalParams: {
          //         title: "用户组人员管理",
          //         children: "Bla bla456 .."
          //       }
          //     }
          //   }
          // }
        ],
        commonOperate: {
          delete: true
        }
      }
    }
  }
};

let reduxTemplateCofig = (args) => {
  const {groupId} = args;
  const apis = {
    list: {
      path: `${componentName}/groupUserList`,
      payload: {
        key: `${componentName}@groupUserList`,
        apiParams: {pageNum: 1, pageSize: 10, groupId: groupId}
      }
    },
    add: {
      path: `${componentName}/addGroupUser`,
      payload: {
        key: `${componentName}@addGroupUser`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/deleteGroupUser`,
      payload: {
        key: `${componentName}@deleteGroupUser`,
        apiParams: {}
      }
    }
  };
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
